module.exports = __webpack_public_path__ + "img/lever08.5ba109fb.png";